import React from "react";

import { SanityImage2 } from "@bared/ui";

import { ClickableImageWrapper } from "../Styled/Image";

import type { ImageProps } from "./withImage";

/**
 * This component is here to support removal of the gatsby-plugin-image
 * dependency without updating every legacy component. It should NOT be
 * used for anything new.
 *
 * @deprecated use SanityImage or ShopifyImage directly
 */
export function GatsbyImage({
  alt,
  image,
  className,
  onClick,
  fullHeight,
  imageLink,
  staticImage,
}: ImageProps) {
  const assetId = image?.asset?._ref;

  if (!assetId) {
    console.warn(
      `Asset ID could not be resolved in legacy GatsbyImage component`,
    );

    return null;
  }

  const maxWidth = image?.displayWidth ?? image?.width;

  const isClickable = onClick && typeof onClick === "function" && !!imageLink;

  return (
    <ClickableImageWrapper
      as={isClickable && "a"}
      onClick={isClickable ? () => onClick(imageLink) : null}
    >
      {staticImage ? (
        <div
          style={{
            backgroundImage: `url(${image?.src})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "100%",
            height: fullHeight ? "100%" : "auto",
          }}
        />
      ) : (
        <SanityImage2
          src={assetId}
          alt={alt ?? ""}
          sizes={
            maxWidth
              ? `(min-width: ${maxWidth}px) ${maxWidth}px, 100vw`
              : "100vw"
          }
          className={className}
        />
      )}
    </ClickableImageWrapper>
  );
}
